<template>
  <div class="content-container">
    <el-breadcrumb separator="/" v-if="!customer">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>拜访记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <h6 class="content-header">客户</h6> -->
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="70px"
        >
          <el-form-item label="客户名称" v-if="isMobile() && !filterShow">
            <customer-select
              :val="filter.customer_id"
              @change="filter.customer_id = $event"
            ></customer-select>
          </el-form-item>
          <div class="filter-block" v-show="filterShow || !isMobile()">
            <el-form-item
              label="客户名称"
              v-if="filterShow || (!isMobile() && !customer)"
            >
              <customer-select
                :val="filter.customer_id"
                @change="filter.customer_id = $event"
              ></customer-select>
            </el-form-item>
            <el-form-item label="拜访类型">
              <el-select
                size="small"
                v-model="filter.type"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in followupTypes"
                  :key="item.label"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="销售">
              <sale-select
                :val="filter.user_id"
                @change="filter.user_id = $event"
              ></sale-select>
            </el-form-item>
            <el-form-item label="拜访日期">
              <el-date-picker
                v-model="filter.date"
                type="daterange"
                size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </div>
        </el-form>
        <div class="mt-10 flex-row-between">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                requestCustomerFollowups()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </div>
          <div
            class="flex-row-base"
            v-if="isMobile()"
            @click="
              filterShow = !filterShow
              scrollToTop()
            "
          >
            <i
              class="text-gray"
              :class="filterShow ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
            ></i>
            <span class="text-info-12">
              {{ filterShow ? '隐藏高级筛选' : '展开高级筛选' }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel mt-20">
      <el-button
        type="primary"
        icon="el-icon-notebook-2"
        size="small"
        @click="startCreateFollowup"
        v-if="!customer || customer.deleted == 0"
        v-permission="Auth.customerFollowUpNew"
        >新拜访</el-button
      >
      <el-table
        v-if="!isMobile()"
        :data="followups"
        stripe
        style="width: 100%"
        key="followups2"
      >
        <el-table-column prop="origin" label="拜访客户" v-if="!customer">
          <template slot-scope="scope">
            <customer-link
              :customer="scope.row.customer"
              :dealer="false"
            ></customer-link>
          </template>
        </el-table-column>
        <el-table-column prop="origin" label="拜访类型">
          <template slot-scope="scope">
            <span>{{ followupTypeMap[scope.row.type] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="user"
          label="拜访对象"
          width="100"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.customer_contact.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="date"
          label="拜访日期"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ formatTime(scope.row.created_at) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="amount"
          label="费用（￥）"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column prop="origin" label="销售" width="100" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.user.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="origin" label="操作" width="100" align="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              plain
              @click="showContent(scope.row)"
              >查看内容</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <ul class="list-style" v-else>
        <li v-for="(item, index) in followups">
          <div class="flex-row-between">
            <span>{{ followupTypeMap[item.type] }}</span>
            <el-button
              size="mini"
              type="primary"
              plain
              @click="showContent(item)"
              >查看内容</el-button
            >
          </div>
          <div>
            <customer-link
              class="font-12"
              :customer="item.customer"
            ></customer-link>
          </div>
          <div class="text-info-12 flex-row-between">
            <span>拜访对象：{{ item.customer_contact.name }}</span>
            <span v-if="item.amount > 0">费用：￥{{ item.amount }}</span>
          </div>
          <div class="text-info-12 flex-row-between">
            <span>拜访日期： {{ formatTime(item.created_at) }}</span>
          </div>
        </li>
      </ul>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <followup-former
      :model="followUpForm"
      :show.sync="createFollowupFormVisible"
      @created="createdFollowup"
    ></followup-former>
    <customer-selector
      :show.sync="customerSelectorVisible"
      :activeCustomers="activeCustomers"
      @selected="selectedFollowCustomer"
    ></customer-selector>
    <el-dialog
      title="拜访详情"
      :visible.sync="contentDialogVisible"
      width="500px"
    >
      <template v-if="selectFollow">
        <ul class="modal-detail">
          <li>
            <span class="title">拜访客户</span>
            <span>{{ selectFollow.customer.name }}</span>
          </li>
          <li>
            <span class="title">拜访对象</span>
            <span>{{ selectFollow.customer_contact.name }}</span>
          </li>
          <li>
            <span class="title">拜访类型</span>
            <span>{{ followupTypeMap[selectFollow.type] }}</span>
          </li>
          <li>
            <span class="title">拜访日期</span>
            <span>{{ formatTime(selectFollow.created_at) }}</span>
          </li>
          <li>
            <span class="title">下次拜访时间</span>
            <span>{{ formatTime(selectFollow.next_date) }}</span>
          </li>
          <li>
            <span class="title">拜访类型</span>
            <span>{{ followupTypeMap[selectFollow.type] }}</span>
          </li>
          <li>
            <span class="title">销售</span>
            <span>{{ selectFollow.user.name }}</span>
          </li>
          <li>
            <span class="title">费用</span>
            <span>￥{{ selectFollow.amount }}</span>
          </li>
          <li>
            <span class="title">拜访内容</span>
            <span>{{ selectFollow.content }}</span>
          </li>
          <li>
            <span class="title">图片</span>
            <span>
              <viewer
                v-if="selectFollow.pics && selectFollow.pics.length > 0"
                class="viewer"
                ref="viewer"
              >
                <template slot-scope="scope2">
                  <auth-img
                    tag="el-image"
                    v-for="pic in selectFollow.pics"
                    :key="pic"
                    :src="pic"
                    :preview-src-list="selectFollow.pics"
                  />
                </template>
              </viewer>
              <span v-else class="text-gray"> 无图片 </span>
            </span>
          </li>
        </ul>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getStore } from '@/config/storage'
import { customerFollowupList, customerActiveList } from '../../service/getData'
import { regionDataPlus } from '@/util/area_tool'
import CustomerSelect from '@/components/select/customer_select'
import SaleSelect from '@/components/select/sale_select'
import auth from '@/util/auth'
import { CodeToText } from '@/util/area_tool'
import { isMobile, formatTime, scrollToTop } from '@/util/index'
import { CustomerFollowupTypes, FunctionalRoles } from '@/config/global'
import FollowupFormer from '@/components/followup'
import CustomerSelector from '@/components/customer_selector'
import {
  urlPerfix,
  host,
  thumbnailImagePath,
  originImagePath,
} from '@/config/env'
import { clone } from '@/util'

export default {
  components: {
    CustomerSelect,
    SaleSelect,
    FollowupFormer,
    CustomerSelector,
  },
  props: {
    customer: { type: Object },
  },
  data() {
    return {
      FunctionalRoles,
      filter: {
        date: null,
        customer_id: null,
        user_id: null,
        type: null,
        size: 20,
        page: 1,
      },
      thumbnailImagePath,
      followupTypes: clone(CustomerFollowupTypes),
      originImagePath,
      scrollToTop,
      filterShow: false,
      followUpForm: {},
      createFollowupFormVisible: false,
      customerSelectorVisible: false,
      formatTime,
      isMobile,
      total: 0,
      auth,
      followups: [],
      loading: false,
      contentDialogVisible: false,
      selectFollow: null,
      activeCustomers: [],
    }
  },
  watch: {
    'filter.page': function () {
      this.requestCustomerFollowups()
    },
  },
  computed: {
    followupTypeMap() {
      let map = {}
      CustomerFollowupTypes.map((item) => {
        map[item.value] = item.label
      })
      return map
    },
  },
  created() {
    this.followupTypes.unshift({
      label: '所有类型',
      value: 0,
    })

    this.filter = {
      date: this.$route.query.date || [],
      customer_id: parseInt(this.$route.query.customer_id || 0),
      user_id: parseInt(this.$route.query.user_id || 0),
      size: parseInt(this.$route.query.size || 20),
      page: parseInt(this.$route.query.page || 1),
      type: parseInt(this.$route.query.type || 0),
    }

    this.requestCustomerFollowups()
    this.requestActiveCustomer()
  },
  methods: {
    async requestCustomerFollowups() {
      this.loading = true
      let data = {
        page: this.filter.page - 1,
        size: this.filter.size,
        customer_id: this.filter.customer_id || 0,
        user_id: this.filter.user_id || 0,
        type: this.filter.type || 0,
      }

      if (this.customer && this.customer.id > 0) {
        data.customer_id = this.customer.id
      }

      this.$router.replace({
        query: this.filter,
      })

      if (this.filter.date && this.filter.date.length == 2) {
        data.start_date = this.filter.date[0] || ''
        data.end_date = this.filter.date[1] || ''
      }

      let res = await customerFollowupList(data)
      if (res.code == 0) {
        this.followups = res.data.list
        this.total = res.data.total
      }
      this.loading = false
    },
    refresh() {
      this.requestCustomerFollowups()
    },
    reset() {
      this.filter.user_id = 0
      this.filter.customer_id = 0
      this.filter.date = []
      this.filter.page = 1
      this.filter.type = 0
      this.requestCustomerFollowups()
    },
    createdFollowup(item) {
      this.followups.unshift(item)
    },
    async requestActiveCustomer() {
      let res = await customerActiveList()
      if (res.code == 0) {
        this.activeCustomers = res.data.list
      }
    },
    selectedFollowCustomer(customer) {
      this.followUpForm = {
        customer_id: customer.id,
        customer_name: customer.name,
        type: 1,
        date: new Date(),
        next_date: null,
        amount: '',
        quotation_id: null,
        content: '',
        pics: [],
        customer_contact_id: null,
      }
      this.createFollowupFormVisible = true
    },
    startCreateFollowup() {
      if (this.customer) {
        this.selectedFollowCustomer(this.customer)
      } else {
        this.customerSelectorVisible = true
      }
    },
    showContent(item) {
      this.contentDialogVisible = true
      this.selectFollow = item
    },
  },
}
</script>

<style scoped>
.modal-detail li {
  line-height: 2;
  display: flex;
}
.modal-detail li .title {
  display: inline-block;
  width: 90px;
  color: gray;
}

.modal-detail li span:last-child {
  flex: 1;
}
@media (max-width: 767px) {
  .modal-follow-content {
    padding-bottom: 20px;
  }
}
</style>